import { Searcher } from 'fast-fuzzy';
import { IGroupedOption, ISelectOption, LoadOptionsFunc, SelectOptionType } from './selectTypes';
import { useMemo } from 'react';
import debounce from 'debounce-promise';
import { GroupBase, OptionsOrGroups } from 'react-select/dist/declarations/src/types';

export const createLoadOptionsFunc: (options: SelectOptionType[]) => LoadOptionsFunc = (options) => {
  const list: ISelectOption[] = options.reduce(
    (a, b) => ((b as IGroupedOption).options ? [...a, ...(b as IGroupedOption).options] : [...a, b as ISelectOption]),
    [] as ISelectOption[]
  );
  const searcher = new Searcher(list, { keySelector: (x) => x.label });

  return (input) => Promise.resolve(searcher.search(input));
};

type LoadOptions<Option, Group extends GroupBase<Option>> =
  | ((inputValue: string, callback: (options: OptionsOrGroups<Option, Group>) => void) => void)
  | ((inputValue: string) => Promise<OptionsOrGroups<Option, Group>>);

export const useDebounceLoadOptions = <Option, Group extends GroupBase<Option>>(loadOptions: LoadOptions<Option, Group>, debounceInMs: number) =>
  useMemo(() => debounce(loadOptions, debounceInMs), [debounceInMs]);

export { createFilter } from 'react-select';
